<template>
  <!--begin::Card-->
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body p-0">
      <!--begin::Heading-->
      <div class="card-px text-center py-0 my-10">
        <!--begin::Title-->
        <h2 class="fs-1x fw-bolder mb-5">
          {{
            tipo_orden_valor === "traslados"
              ? "Lista de Traslados Judiciales o Administrativos"
              : tipo_orden_valor === "salidas"
              ? "Lista de Salidas"
              : tipo_orden_valor === "detencion_domiciliaria"
              ? "Lista de Detenciones Domiciliarias"
              : tipo_orden_valor === "extramuro"
              ? "Lista de Salidas por Extramuro"
              : tipo_orden_valor === "libertad_condicional"
              ? "Lista de Salidas por Libertad Condicional"
              : tipo_orden_valor === "libertad_provisional"
              ? "Lista de Salidas por Libertad Provisional"
              : tipo_orden_valor === "suspension_condicional_pena"
              ? "Lista de Salidas por Suspensión Condicional de la Pena"
              : tipo_orden_valor === "suspension_condicional_proceso"
              ? "Lista de Salidas por Suspensión Condicional del Proceso"
              : tipo_orden_valor === "perdon_judicial"
              ? "Lista de Salidas por Perdón Judicial"
              : tipo_orden_valor === "fallecimiento"
              ? "Lista de Privados de Libertad Fallecidos"
              : tipo_orden_valor === "evasion"
              ? "Lista de Evasión de Privados de Libertad"
              : ""
          }}
          <span
            v-if="tipo"
            :class="[
              tipo === 'traslado_llegadas' ||
              tipo === 'salidas_pendientes' ||
              tipo === 'detencion_domiciliaria_activas' ||
              tipo === 'extramuro_activas' ||
              tipo === 'libertad_condicional_activas' ||
              tipo === 'libertad_provisional_activas' ||
              tipo === 'suspension_condicional_pena_activas' ||
              tipo === 'suspension_condicional_proceso_activas' ||
              tipo === 'perdon_judicial_activas' ||
              tipo === 'fallecimiento' ||
              tipo === 'evasion_activas'
                ? 'badge bg-primary'
                : tipo === 'traslado_salidas' ||
                  tipo === 'salidas_revisadas' ||
                  tipo === 'detencion_domiciliaria_revocadas' ||
                  tipo === 'extramuro_revocadas' ||
                  tipo === 'libertad_condicional_revocadas' ||
                  tipo === 'libertad_provisional_revocadas' ||
                  tipo === 'suspension_condicional_pena_revocadas' ||
                  tipo === 'suspension_condicional_proceso_revocadas' ||
                  tipo === 'evasion_recapturas'
                ? 'badge bg-success'
                : '',
            ]"
          >
            {{
              tipo === "traslado_llegadas"
                ? "LLEGADAS"
                : tipo === "traslado_salidas"
                ? "SALIDAS"
                : tipo === "salidas_pendientes"
                ? "PENDIENTES"
                : tipo === "salidas_revisadas"
                ? "REVISADAS"
                : tipo === "detencion_domiciliaria_activas" ||
                  tipo === "extramuro_activas" ||
                  tipo === "libertad_condicional_activas" ||
                  tipo === "libertad_provisional_activas" ||
                  tipo === "suspension_condicional_pena_activas" ||
                  tipo === "suspension_condicional_proceso_activas" ||
                  tipo === "perdon_judicial_activas" ||
                  tipo === "evasion_activas"
                ? "ACTIVAS"
                : tipo === "detencion_domiciliaria_revocadas" ||
                  tipo === "extramuro_revocadas" ||
                  tipo === "libertad_condicional_revocadas" ||
                  tipo === "libertad_provisional_revocadas" ||
                  tipo === "suspension_condicional_pena_revocadas" ||
                  tipo === "suspension_condicional_proceso_revocadas"
                ? "REVOCADAS"
                : tipo === "evasion_recapturas"
                ? "RECAPTURAS"
                : ""
            }}</span
          >
        </h2>
        <!--end::Title-->
        <!--begin::Description-->
        <h3
          class="p-6"
          v-if="rol !== 'supervisor' && rol !== 'consultas departamentales'"
        >
          {{
            nombre_recinto_penitenciario === "TODOS"
              ? ""
              : "CENTRO PENITENCIARIO: "
          }}
          {{
            nombre_recinto_penitenciario === "TODOS"
              ? "TODOS LOS RECINTOS"
              : nombre_recinto_penitenciario
          }}
          -
          {{
            departamento_centro_penitenciario === "NACIONAL"
              ? "NIVEL NACIONAL"
              : departamento_centro_penitenciario
          }}
        </h3>
        <h3
          class="p-10"
          v-else-if="
            rol === 'supervisor' || rol === 'consultas departamentales'
          "
        >
          SUPERVISIÓN:
          {{
            departamento_supervisar === "NACIONAL"
              ? "NIVEL NACIONAL"
              : departamento_supervisar
          }}
        </h3>
        <p class="text-gray-600 fs-6 fw-bold mb-0">
          <span v-if="tipo">
            Información actualizada a : {{ currentDateView }}</span
          >
        </p>
        <div v-if="tipo" class="row">
          <div class="col-md-12 col-md-offset-2">
            <!-- botones -->
            <div
              v-for="type of types"
              :key="type.name"
              class="card-body d-flex"
            >
              <button
                v-if="type.name !== tipo"
                type="button"
                :class="[
                  type.name === 'traslado_llegadas' ||
                  type.name === 'salidas_pendientes' ||
                  type.name === 'detencion_domiciliaria_activas' ||
                  type.name === 'extramuro_activas' ||
                  type.name === 'libertad_condicional_activas' ||
                  type.name === 'libertad_provisional_activas' ||
                  type.name === 'suspension_condicional_pena_activas' ||
                  type.name === 'suspension_condicional_proceso_activas' ||
                  type.name === 'perdon_judicial_activas' ||
                  type.name === 'fallecimiento' ||
                  type.name === 'evasion_activas'
                    ? 'btn btn-primary px-3 m-2'
                    : 'btn btn-success px-3 m-2',
                ]"
                @click="list(type.name)"
              >
                {{
                  type.name === "detencion_domiciliaria_activas"
                    ? "Detenciones domiciliarias activas"
                    : type.name === "detencion_domiciliaria_revocadas"
                    ? "Detenciones domiciliarias Revocadas"
                    : type.name === "extramuro_activas"
                    ? "Salidas por Extramuro Activas"
                    : type.name === "extramuro_revocadas"
                    ? "Salidas por Extramuro Revocadas"
                    : type.name === "libertad_condicional_activas"
                    ? "Salidas por Libertad Condicional Activas"
                    : type.name === "libertad_provisional_activas"
                    ? "Salidas por Libertad Provisional Activas"
                    : type.name === "libertad_condicional_revocadas"
                    ? "Salidas por Libertad Condicional Revocadas"
                    : type.name === "libertad_provisional_revocadas"
                    ? "Salidas por Libertad Provisional Revocadas"
                    : type.name === "suspension_condicional_pena_revocadas" ||
                      type.name === "suspension_condicional_proceso_revocadas"
                    ? "Salidas Revocadas"
                    : type.name === "suspension_condicional_pena_activas" ||
                      type.name === "suspension_condicional_proceso_activas"
                    ? "Salidas Activas"
                    : type.name === "evasion_activas"
                    ? "Registro de Evasiones Activas"
                    : type.name === "evasion_recapturas"
                    ? "Registro de Recapturas"
                    : type.name[0].toUpperCase() +
                      type.name.substring(1).replace(/_/g, " ")
                }}
              </button>
            </div>
          </div>
        </div>
        <!-- tabla con contenido -->
        <div v-if="dataTable.length > 0" class="card-body pt-0">
          <DxDataGrid
            id="gridContainer"
            ref="dataGridRef"
            :data-source="dataTable"
            key-expr="id_traslado_salida"
            :allow-column-reordering="false"
            :row-alternation-enabled="false"
            :show-borders="true"
            @exporting="onExporting"
          >
            <DxFilterRow :visible="true" />
            <DxHeaderFilter :visible="true" />
            <DxPager
              :visible="true"
              :allowed-page-sizes="pageSizes"
              :show-page-size-selector="true"
            />
            <DxPaging :page-size="10" />
            <DxGroupPanel :visible="true" />
            <DxGrouping :auto-expand-all="false" />
            <DxExport :enabled="true" :allow-export-selected-data="true" />
            <DxSelection mode="multiple" show-check-boxes-mode="always" />
            <DxColumn
              :width="tipo !== 'fallecimiento' ? 390 : 200"
              :allow-sorting="false"
              caption="Acciones"
              cell-template="cellTemplate"
            />
            <template #cellTemplate="{ data }">
              <!-- ver resolución -->
              <button
                v-if="
                  data.data.documento_respaldo_traslado_salida &&
                  tipo !== 'detencion_domiciliaria_revocadas' &&
                  tipo !== 'extramuro_revocadas' &&
                  tipo !== 'libertad_condicional_revocadas' &&
                  tipo !== 'libertad_provisional_revocadas' &&
                  tipo !== 'suspension_condicional_pena_revocadas' &&
                  tipo !== 'suspension_condicional_proceso_revocadas' &&
                  tipo !== 'evasion_recapturas'
                "
                type="button"
                class="btn px-3"
                @click="viewResolution(data.data.id_traslado_salida)"
              >
                <i
                  title="Ver PDF"
                  style="font-size: 1.5em; color: green"
                  class="fas fa-eye"
                ></i>
              </button>
              <!-- ver resolución de revocación-->
              <button
                v-if="
                  (tipo === 'detencion_domiciliaria_revocadas' ||
                    tipo === 'extramuro_revocadas' ||
                    tipo === 'libertad_condicional_revocadas' ||
                    tipo === 'libertad_provisional_revocadas' ||
                    tipo === 'suspension_condicional_pena_revocadas' ||
                    tipo === 'suspension_condicional_proceso_revocadas' ||
                    tipo === 'evasion_recapturas') &&
                  data.data.documento_respaldo_revocacion
                "
                type="button"
                class="btn px-3"
                @click="viewResolutionRevocation(data.data.id_traslado_salida)"
              >
                <i
                  :title="
                    tipo === 'evasion_recapturas'
                      ? 'Documentación recaptura'
                      : 'Ver resolución de revocación'
                  "
                  style="font-size: 1.5em; color: blue"
                  class="fas fa-eye"
                ></i>
              </button>
              <!-- subir archivo de mandamiento -->
              <button
                v-if="
                  (tipo === 'traslado_salidas' ||
                    tipo === 'salidas_pendientes' ||
                    tipo === 'detencion_domiciliaria_activas' ||
                    tipo === 'extramuro_activas' ||
                    tipo === 'libertad_condicional_activas' ||
                    tipo === 'libertad_provisional_activas' ||
                    tipo === 'suspension_condicional_pena_activas' ||
                    tipo === 'suspension_condicional_proceso_activas' ||
                    tipo === 'perdon_judicial_activas' ||
                    tipo === 'fallecimiento' ||
                    tipo === 'evasion_activas') &&
                  !data.data.documento_respaldo_traslado_salida &&
                  (rol !== 'consultas nacional' ||
                    rol !== 'consultas departamentales')
                "
                type="button"
                class="btn px-3"
                @click="uploadResolution(data.data.id_traslado_salida)"
              >
                <i
                  title="Subir resolución"
                  style="font-size: 1.5em; color: teal"
                  class="fas fa-upload"
                ></i>
              </button>
              <input
                v-if="!data.data.documento_respaldo_traslado_salida"
                :id="data.data.id_traslado_salida"
                type="file"
                ref="file"
                @change="handleFileUpload($event, data.data, tipo_orden_valor)"
                accept="application/pdf"
                hidden
              />
              <!-- subir archivo de mandamiento de revocación -->
              <button
                v-if="
                  (tipo === 'detencion_domiciliaria_revocadas' ||
                    tipo === 'extramuro_revocadas' ||
                    tipo === 'libertad_condicional_revocadas' ||
                    tipo === 'libertad_provisional_revocadas' ||
                    tipo === 'suspension_condicional_pena_revocadas' ||
                    tipo === 'suspension_condicional_proceso_revocadas' ||
                    tipo === 'evasion_recapturas') &&
                  !data.data.documento_respaldo_revocacion &&
                  (rol !== 'consultas nacional' ||
                    rol !== 'consultas departamentales')
                "
                type="button"
                class="btn px-3"
                @click="uploadResolution(data.data.id_traslado_salida)"
              >
                <i
                  :title="
                    tipo === 'evasion_recapturas'
                      ? 'Documentación recaptura'
                      : 'Subir resolución de revocación'
                  "
                  style="font-size: 1.5em; color: green"
                  class="fas fa-upload"
                ></i>
              </button>
              <input
                v-if="!data.data.documento_respaldo_revocacion"
                :id="data.data.id_traslado_salida"
                type="file"
                ref="file"
                @change="
                  handleFileUploadRevocation(
                    $event,
                    data.data,
                    tipo_orden_valor
                  )
                "
                accept="application/pdf"
                hidden
              />
              <!-- eliminar orden judicial -->
              <button
                v-if="
                  tipo !== 'detencion_domiciliaria_revocadas' &&
                  tipo !== 'extramuro_revocadas' &&
                  tipo !== 'libertad_condicional_revocadas' &&
                  tipo !== 'libertad_provisional_revocadas' &&
                  tipo !== 'suspension_condicional_pena_revocadas' &&
                  tipo !== 'suspension_condicional_proceso_revocadas' &&
                  tipo !== 'evasion_recapturas' &&
                  data.data.documento_respaldo_traslado_salida != null &&
                  (rol === 'admin' || rol === 'editor')
                "
                type="button"
                class="btn px-3"
                @click="deleteResolution(data.data, tipo_orden_valor)"
              >
                <i
                  title="Eliminar Resolución"
                  style="font-size: 1.5em; color: indianred"
                  class="fas fa-file-circle-xmark"
                ></i>
              </button>
              <!-- eliminar archivo revocación -->
              <button
                v-if="
                  (tipo === 'detencion_domiciliaria_revocadas' ||
                    tipo === 'extramuro_revocadas' ||
                    tipo === 'libertad_condicional_revocadas' ||
                    tipo === 'libertad_provisional_revocadas' ||
                    tipo === 'suspension_condicional_pena_revocadas' ||
                    tipo === 'suspension_condicional_proceso_revocadas' ||
                    tipo === 'evasion_recapturas') &&
                  data.data.documento_respaldo_revocacion &&
                  (rol === 'admin' || rol === 'editor')
                "
                type="button"
                class="btn px-3"
                @click="deleteResolutionRevocation(data.data, tipo_orden_valor)"
              >
                <i
                  :title="
                    tipo === 'evasion_recapturas'
                      ? 'Eliminar documentación de recaptura'
                      : 'Eliminar Resolución de Revocación'
                  "
                  style="font-size: 1.5em; color: brown"
                  class="fas fa-file-circle-xmark"
                ></i>
              </button>
              <!-- reimprimir kardex -->
              <button
                v-if="
                  tipo !== 'detencion_domiciliaria_revocadas' &&
                  tipo !== 'extramuro_revocadas' &&
                  tipo !== 'libertad_condicional_revocadas' &&
                  tipo !== 'libertad_provisional_revocadas' &&
                  tipo !== 'suspension_condicional_pena_revocadas' &&
                  tipo !== 'suspension_condicional_proceso_revocadas'
                "
                type="button"
                class="btn px-3"
                @click="
                  printKardex(data.data.id_traslado_salida, tipo_orden_valor)
                "
              >
                <i
                  title="Reimprimir kardex"
                  style="font-size: 1.5em; color: grey"
                  class="fas fa-print"
                ></i>
              </button>
              <!-- recibir ppl -->
              <button
                v-if="
                  tipo === 'traslado_llegadas' &&
                  !data.data.fecha_ingreso_traslado_recinto &&
                  data.data.documento_respaldo_traslado_salida &&
                  (rol !== 'consultas nacional' ||
                    rol !== 'consultas departamentales')
                "
                type="button"
                class="btn px-3"
                @click="confirmReception(data.data)"
              >
                <i
                  title="Recibir Traslado del Privado de libertad"
                  style="font-size: 1.5em; color: blue"
                  class="fas fa-person-arrow-down-to-line"
                ></i>
              </button>
              <!-- confirmar salidas -->
              <button
                v-if="
                  tipo === 'salidas_pendientes' &&
                  data.data.documento_respaldo_traslado_salida &&
                  (rol !== 'consultas nacional' ||
                    rol !== 'consultas departamentales')
                "
                type="button"
                class="btn px-3"
                @click="approveLiberty(data.data)"
              >
                <i
                  title="Aprobar Salida Privado de libertad"
                  style="font-size: 1.5em; color: teal"
                  class="fas fa-door-open"
                >
                </i>
              </button>
              <!-- rechazar salida libertad -->
              <button
                v-if="
                  tipo === 'salidas_revisadas' &&
                  data.data.observacion_rechazo_salida_libertad &&
                  (rol !== 'consultas nacional' ||
                    rol !== 'consultas departamentales')
                "
                type="button"
                class="btn px-3"
                @click="deny_details(data.data.id_traslado_salida)"
              >
                <i
                  title="Detalles de la negación a LIBERTAD DEFINITIVA "
                  style="font-size: 1.5em; color: red"
                  class="fas fa-info-circle"
                ></i>
              </button>
              <!-- revocar orden judicial  -->
              <button
                v-if="
                  data.data.documento_respaldo_traslado_salida &&
                  (tipo_orden_valor === 'detencion_domiciliaria' ||
                    tipo_orden_valor === 'extramuro' ||
                    tipo_orden_valor === 'libertad_condicional' ||
                    tipo_orden_valor === 'libertad_provisional' ||
                    tipo_orden_valor === 'suspension_condicional_pena' ||
                    tipo_orden_valor === 'suspension_condicional_proceso' ||
                    tipo_orden_valor === 'perdon_judicial') &&
                  (tipo === 'detencion_domiciliaria_activas' ||
                    tipo === 'extramuro_activas' ||
                    tipo === 'libertad_condicional_activas' ||
                    tipo === 'libertad_provisional_activas' ||
                    tipo === 'suspension_condicional_pena_activas' ||
                    tipo === 'suspension_condicional_proceso_activas' ||
                    tipo === 'perdon_judicial_activas')
                "
                type="button"
                class="btn px-3"
                @click="repealOrder(data.data, tipo_orden_valor)"
              >
                <i
                  title="Revocar orden"
                  style="font-size: 1.5em; color: brown"
                  class="fas fa-person-walking-arrow-loop-left"
                ></i>
              </button>
              <!-- registrar recaptura  -->
              <button
                v-if="
                  data.data.documento_respaldo_traslado_salida &&
                  tipo === 'evasion_activas'
                "
                type="button"
                class="btn px-3"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
              >
                <i
                  title="Registrar Recaptura"
                  style="font-size: 1.5em; color: red"
                  class="fas fa-person-walking-arrow-loop-left"
                ></i>
              </button>
              <div
                ref="modalRef"
                class="modal fade"
                id="staticBackdrop"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabindex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="staticBackdropLabel">
                        Registro Recaptura
                      </h1>
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        @click="clearInput"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <!-- fecha fallecimiento -->
                      <div class="col-md-12 mt-3">
                        <label class="form-label required"
                          >Fecha y hora de la recaptura:</label
                        >
                        <Datepicker
                          id="fecha_recaptura"
                          v-model="state.formData.fecha_recaptura"
                          type="date"
                          locale="es"
                          cancelText="Cancelar"
                          selectText="Seleccionar"
                          monthNameFormat="long"
                          :enableTimePicker="true"
                          :format="formatDateAndHours"
                          :previewFormat="formatDateAndHours"
                          :maxDate="currentDate"
                          required
                          @update:modelValue="deleteValidation"
                        ></Datepicker>
                      </div>
                      <div class="input-errors" v-if="sinFechaRecaptura">
                        <span class="text-danger"
                          >La fecha de recaptura es requerida</span
                        >
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                        @click="clearInput"
                      >
                        Cerrar
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="recapturePpl(data.data, tipo_orden_valor)"
                      >
                        Registrar
                      </button>
                      <button
                        type="button"
                        class="btn btn-success"
                        @click="
                          save_and_register_new_order({
                            info: data.data,
                            tipo: tipo_orden_valor,
                            id_persona: data.data.id_persona,
                            id_orden: 0,
                            add: 'register',
                          })
                        "
                      >
                        Registrar e Iniciar Nuevo Proceso
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- editar datos -->
              <!-- <button
                type="button"
                class="btn px-3"
                v-if="rol === 'admin' || rol === 'editor'"
                @click="EditData(data.data)"
              >
                <i
                  title="Editar información del privado de libertad"
                  style="font-size: 1.5em; color: silver"
                  class="fas fa-edit"
                ></i>
              </button> -->
              <!-- badge info -->
              <span
                v-if="tipo_orden_valor === 'traslados'"
                :title="[
                  data.data.fecha_ingreso_traslado_recinto
                    ? 'Ppl recibido'
                    : 'Ppl pendiente de recepción',
                ]"
                :class="[
                  data.data.fecha_ingreso_traslado_recinto
                    ? 'badge bg-success'
                    : 'badge bg-warning',
                ]"
              >
                {{
                  data.data.fecha_ingreso_traslado_recinto
                    ? "RECIBIDO"
                    : "PENDIENTE"
                }}
              </span>
              <span
                v-if="tipo === 'salidas_revisadas'"
                :class="[
                  data.data.fecha_autorizacion_salida_libertad
                    ? 'badge bg-success'
                    : 'badge bg-warning',
                ]"
              >
                {{
                  data.data.fecha_autorizacion_salida_libertad
                    ? "APROBADO"
                    : "RECHAZADO"
                }}
              </span>
            </template>
            <DxColumn
              :width="170"
              data-field="codigo_file_ppl"
              :allow-grouping="false"
              caption="Código file PPL"
            />
            <DxColumn
              :width="300"
              data-field="persona_ppl"
              :allow-grouping="false"
              caption="Nombre PPL"
            />
            <DxColumn
              :width="170"
              data-field="genero"
              :allow-grouping="true"
              caption="Género"
            />
            <DxColumn
              :width="200"
              data-field="nro_documento"
              :allow-grouping="true"
              caption="Nro. Documento"
            />
            <DxColumn
              v-if="
                tipo_orden_valor !== 'fallecimiento' &&
                tipo_orden_valor !== 'evasion'
              "
              :width="200"
              data-field="fecha_orden"
              data-type="date"
              :format="DateFormat"
              caption="Fecha Orden"
            />
            <DxColumn
              v-if="
                tipo === 'detencion_domiciliaria_revocadas' ||
                tipo === 'extramuro_revocadas' ||
                tipo === 'libertad_condicional_revocadas' ||
                tipo === 'libertad_provisional_revocadas' ||
                tipo === 'suspension_condicional_pena_revocadas' ||
                tipo === 'suspension_condicional_proceso_revocadas'
              "
              :width="200"
              data-field="fecha_reversion_orden"
              data-type="date"
              :format="DateFormat"
              caption="Fecha Revocación"
            />
            <DxColumn
              v-if="
                tipo_orden_valor !== 'fallecimiento' &&
                tipo_orden_valor !== 'evasion'
              "
              :width="250"
              data-field="descripcion_tipo_mandamiento"
              :allow-grouping="false"
              caption="Tipo Orden"
            />
            <DxColumn
              v-if="
                tipo_orden_valor !== 'fallecimiento' &&
                tipo_orden_valor !== 'evasion'
              "
              :width="250"
              data-field="nombre_completo_autoridad"
              :allow-grouping="false"
              caption="Autoridad que emite la Orden"
            />
            <DxColumn
              v-if="
                tipo_orden_valor !== 'fallecimiento' &&
                tipo_orden_valor !== 'evasion'
              "
              :width="350"
              data-field="nombre_juzgado"
              :allow-grouping="false"
              caption="Oficina que emite la Orden"
            />
            <DxColumn
              v-if="
                tipo_orden_valor !== 'fallecimiento' &&
                tipo_orden_valor !== 'evasion'
              "
              :width="250"
              data-field="nombre_codigo"
              :allow-grouping="false"
              caption="Código único"
            />
            <DxColumn
              v-if="
                tipo_orden_valor !== 'fallecimiento' &&
                tipo_orden_valor !== 'evasion'
              "
              :width="200"
              data-field="codigo_unico"
              :allow-grouping="false"
              caption="Nro. Código Único"
            />
            <DxColumn
              v-if="tipo === 'fallecimiento'"
              :width="350"
              data-field="nombre_tipo_deceso"
              caption="Causa del Deceso"
            />
            <DxColumn
              v-if="tipo === 'fallecimiento'"
              :width="350"
              data-field="lugar_deceso"
              :allow-grouping="false"
              caption="Lugar del Deceso"
            />
            <DxColumn
              v-if="tipo === 'fallecimiento'"
              :width="350"
              data-field="certificado_defuncion"
              :allow-grouping="false"
              caption="N° Certificado de Defunción"
            />
            <DxColumn
              v-if="tipo_orden_valor === 'fallecimiento'"
              :width="300"
              data-field="fecha_deceso"
              data-type="date"
              :format="formatDateAndHours"
              caption="Fecha del Deceso"
            />
            <DxColumn
              v-if="tipo_orden_valor === 'evasion'"
              :width="300"
              data-field="fecha_evasion"
              data-type="date"
              :format="formatDateAndHours"
              caption="Fecha de la evasión"
            />
            <DxColumn
              v-if="tipo_orden_valor === 'traslados'"
              :width="350"
              data-field="motivo_traslado"
              :allow-grouping="false"
              caption="Motivo del traslado"
            />
            <DxColumn
              v-if="tipo_orden_valor === 'evasion'"
              :width="350"
              data-field="descripcion_evasion"
              :allow-grouping="false"
              caption="Descripción de la Evasión"
            />
            <DxColumn
              v-if="tipo === 'evasion_recapturas'"
              :width="300"
              data-field="fecha_recaptura"
              data-type="date"
              :format="formatDateAndHours"
              caption="Fecha de la Recaptura"
            />
            <DxColumn
              v-if="tipo_orden_valor === 'traslados'"
              :width="300"
              data-field="fecha_salida_traslado_recinto"
              data-type="date"
              :format="DateFormat"
              :allow-grouping="false"
              caption="Fecha de salida del Centro Penitenciario"
            />
            <DxColumn
              :width="350"
              data-field="anterior"
              caption="Centro Penitenciario"
            />
            <DxColumn
              v-if="tipo === 'traslado_salidas'"
              :width="350"
              data-field="nuevo"
              :allow-grouping="false"
              caption="Centro penitenciario Destino"
            />
            <DxColumn
              :width="350"
              data-field="persona_registro_salida"
              :allow-grouping="false"
              caption="Usuario"
            />
            <DxColumn
              :width="300"
              data-field="fecha_creacion"
              data-type="date"
              :format="DateFormat"
              caption="Fecha de registro"
            />
            <DxColumn
              v-if="tipo === 'traslado_llegadas'"
              :width="350"
              data-field="persona_registro_ingreso"
              :allow-grouping="false"
              caption="Usuario que registró el ingreso del traslado"
            />
            <DxColumn
              v-if="tipo === 'salidas_pendientes'"
              :width="350"
              data-field="fecha_salida_libertad"
              data-type="date"
              :format="DateFormat"
              caption="Fecha salida libertad"
            />
            <DxColumn
              v-if="tipo === 'salidas_revisadas'"
              :width="350"
              data-field="fecha_autorizacion_salida_libertad"
              data-type="date"
              :format="DateFormat"
              caption="Fecha aprobación de salida libertad"
            />
            <DxColumn
              v-if="tipo === 'salidas_revisadas'"
              :width="350"
              data-field="persona_aprobo_salida"
              :allow-grouping="false"
              caption="Usuario que autorizó salida libertad"
            />
            <DxColumn
              v-if="tipo === 'salidas_revisadas'"
              :width="350"
              data-field="fecha_rechazo_salida_libertad"
              data-type="date"
              :format="DateFormat"
              caption="Fecha rechazo de salida libertad"
            />
            <DxColumn
              v-if="tipo === 'salidas_revisadas'"
              :width="350"
              data-field="persona_rechazo_salida"
              :allow-grouping="false"
              caption="Usuario que rechazó salida libertad"
            />
            <DxColumn
              v-if="tipo === 'traslado_llegadas'"
              :width="300"
              data-field="fecha_ingreso_traslado_recinto"
              data-type="date"
              :format="DateFormat"
              caption="Fecha de ingreso del Centro Penitenciario"
            />
            <DxSearchPanel :visible="true" :highlight-case-sensitive="true" />
            <DxSummary>
              <DxGroupItem
                column="recinto_departamento"
                summary-type="count"
                display-format="{0} Persona(s) Privada de Libertad"
              />
              <DxTotalItem
                column="id_traslado_salida"
                summary-type="count"
                display-format="Total count: {0} Personas privadas de libertad"
              />
            </DxSummary>
            <DxSortByGroupSummaryInfo summary-item="persona_ppl" />
          </DxDataGrid>
        </div>
        <!-- tabla sin datos -->
        <div
          v-else-if="
            (tipo === 'traslado_salidas' ||
              tipo === 'traslado_llegadas' ||
              tipo === 'salidas_pendientes' ||
              tipo === 'salidas_revisadas' ||
              tipo === 'detencion_domiciliaria_activas' ||
              tipo === 'extramuro_activas' ||
              tipo === 'libertad_condicional_activas' ||
              tipo === 'libertad_provisional_activas' ||
              tipo === 'suspension_condicional_pena_activas' ||
              tipo === 'suspension_condicional_proceso_activas' ||
              tipo === 'perdon_judicial_activas' ||
              tipo === 'fallecimiento' ||
              tipo === 'evasion_activas' ||
              tipo === 'detencion_domiciliaria_revocadas' ||
              tipo === 'extramuro_revocadas' ||
              tipo === 'libertad_condicional_revocadas' ||
              tipo === 'libertad_provisional_revocadas' ||
              tipo === 'suspension_condicional_pena_revocadas' ||
              tipo === 'suspension_condicional_proceso_revocadas' ||
              tipo === 'evasion_recapturas') &&
            dataTable.length === 0
          "
        >
          No existen registros de
          {{
            tipo === "traslado_salidas"
              ? "salidas de traslados."
              : tipo === "traslado_llegadas"
              ? "llegadas por traslados."
              : tipo === "salidas_pendientes"
              ? "salidas pendientes de aprobación."
              : tipo === "salidas_revisadas"
              ? "salidas revisadas."
              : tipo === "detencion_domiciliaria_activas"
              ? "detenciones domiciliarias activas."
              : tipo === "extramuro_activas"
              ? "salidas por extramuro activas."
              : tipo === "libertad_condicional_activas"
              ? "salidas por libertad condicional activas."
              : tipo === "libertad_provisional_activas"
              ? "salidas por libertad provisional activas."
              : tipo === "suspension_condicional_pena_activas"
              ? "salidas por libertad  de suspensión condicional de la pena activas."
              : tipo === "suspension_condicional_proceso_activas"
              ? "salidas por libertad  de suspensión condicional del proceso activas."
              : tipo === "perdon_judicial_activas"
              ? "salidas por perdón judicial activas."
              : tipo === "fallecimiento"
              ? "Registros de fallecimiento"
              : tipo === "evasion_activas"
              ? "Evasiones activas."
              : tipo === "detencion_domiciliaria_revocadas"
              ? "detenciones domiciliarias revocadas."
              : tipo === "extramuro_revocadas"
              ? "Salidas por Extramuro revocadas."
              : tipo === "libertad_condicional_revocadas"
              ? "Salidas por libertad condicional revocadas."
              : tipo === "libertad_provisional_revocadas"
              ? "Salidas por libertad provisional revocadas."
              : tipo === "suspension_condicional_pena_revocadas"
              ? "Salidas por libertad de suspensión condicional de la pena revocadas."
              : tipo === "suspension_condicional_proceso_revocadas"
              ? "Salidas por libertad de suspensión condicional del proceso revocadas."
              : tipo === "evasion_recapturas"
              ? "Recapturas de Evasiones."
              : ""
          }}
        </div>
        <!-- sin traslados o salidas -->
        <div v-else-if="!tipo && dataTable.length === 0">
          <p
            v-if="
              tipo_orden_valor !== 'perdon_judicial' &&
              tipo_orden_valor !== 'fallecimiento'
            "
          >
            Por favor seleccione :
          </p>
          <button
            type="button"
            class="btn btn-primary px-3 m-2"
            @click="
              list(
                tipo_orden_valor === 'traslados'
                  ? 'traslado_llegadas'
                  : tipo_orden_valor === 'salidas'
                  ? 'salidas_pendientes'
                  : tipo_orden_valor === 'detencion_domiciliaria'
                  ? 'detencion_domiciliaria_activas'
                  : tipo_orden_valor === 'extramuro'
                  ? 'extramuro_activas'
                  : tipo_orden_valor === 'libertad_condicional'
                  ? 'libertad_condicional_activas'
                  : tipo_orden_valor === 'libertad_provisional'
                  ? 'libertad_provisional_activas'
                  : tipo_orden_valor === 'suspension_condicional_pena'
                  ? 'suspension_condicional_pena_activas'
                  : tipo_orden_valor === 'suspension_condicional_proceso'
                  ? 'suspension_condicional_proceso_activas'
                  : tipo_orden_valor === 'perdon_judicial'
                  ? 'perdon_judicial_activas'
                  : tipo_orden_valor === 'fallecimiento'
                  ? 'fallecimiento'
                  : tipo_orden_valor === 'evasion'
                  ? 'evasion_activas'
                  : ''
              )
            "
          >
            <i
              v-if="tipo_orden_valor !== 'fallecimiento'"
              class="fas fa-sign-in"
            ></i>
            <i v-else class="fas fa-cross"></i>
            {{
              tipo_orden_valor === "traslados"
                ? "Lista de llegadas"
                : tipo_orden_valor === "salidas"
                ? "Salidas pendientes"
                : tipo_orden_valor === "detencion_domiciliaria"
                ? "Detenciones Domiciliarias Activas"
                : tipo_orden_valor === "extramuro"
                ? "Salidas por Extramuro Activas"
                : tipo_orden_valor === "libertad_condicional"
                ? "Salidas por Libertad Condicional Activas"
                : tipo_orden_valor === "libertad_provisional"
                ? "Salidas por Libertad Provisional Activas"
                : tipo_orden_valor === "suspension_condicional_pena" ||
                  tipo_orden_valor === "suspension_condicional_proceso"
                ? "Salidas Activas"
                : tipo_orden_valor === "perdon_judicial"
                ? "Salidas por Perdón Judicial Activas"
                : tipo_orden_valor === "fallecimiento"
                ? "Registro de fallecimientos"
                : tipo_orden_valor === "evasion"
                ? "Registro de Evasiones Activas"
                : ""
            }}
          </button>
          <span
            v-if="
              tipo_orden_valor !== 'perdon_judicial' &&
              tipo_orden_valor !== 'fallecimiento'
            "
            >o</span
          >
          <button
            type="button"
            class="btn btn-success px-3 m-2"
            v-if="
              tipo_orden_valor !== 'perdon_judicial' &&
              tipo_orden_valor !== 'fallecimiento'
            "
            @click="
              list(
                tipo_orden_valor === 'traslados'
                  ? 'traslado_salidas'
                  : tipo_orden_valor === 'salidas'
                  ? 'salidas_revisadas'
                  : tipo_orden_valor === 'detencion_domiciliaria'
                  ? 'detencion_domiciliaria_revocadas'
                  : tipo_orden_valor === 'extramuro'
                  ? 'extramuro_revocadas'
                  : tipo_orden_valor === 'libertad_condicional'
                  ? 'libertad_condicional_revocadas'
                  : tipo_orden_valor === 'libertad_provisional'
                  ? 'libertad_provisional_revocadas'
                  : tipo_orden_valor === 'suspension_condicional_pena'
                  ? 'suspension_condicional_pena_revocadas'
                  : tipo_orden_valor === 'suspension_condicional_proceso'
                  ? 'suspension_condicional_proceso_revocadas'
                  : tipo_orden_valor === 'evasion'
                  ? 'evasion_recapturas'
                  : ''
              )
            "
          >
            <i class="fas fa-sign-out"></i>
            {{
              tipo_orden_valor === "traslados"
                ? "Lista de Salidas"
                : tipo_orden_valor === "salidas"
                ? "Salidas Revisadas"
                : tipo_orden_valor === "detencion_domiciliaria"
                ? "Detenciones Domiciliarias Revocadas"
                : tipo_orden_valor === "extramuro"
                ? "Salidas por Extramuro Revocadas"
                : tipo_orden_valor === "libertad_condicional"
                ? "Salidas por Libertad Condicional Revocadas"
                : tipo_orden_valor === "libertad_provisional"
                ? "Salidas por Libertad Provisional Revocadas"
                : tipo_orden_valor === "suspension_condicional_pena" ||
                  tipo_orden_valor === "suspension_condicional_proceso"
                ? "Salidas Revocadas"
                : tipo_orden_valor === "evasion"
                ? "Registro de Recaptura de Evasiones"
                : ""
            }}</button
          >.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  watch,
  reactive,
} from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import useAuth from "@/auth/composables/useAuth";
import date from "date-and-time";
import es from "date-and-time/locale/es";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver-es";
import { locale, loadMessages } from "devextreme/localization";
import { formatISO } from "date-fns";
import esMessages from "devextreme/localization/messages/es.json";
import addTransfersDepartures from "@/addTransfersDepartures/composables/useAddTransferDeparture";
import formatDate from "@/helpers/formatDate";
import formatDateWithHours from "@/helpers/formatDateWithHours";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import filiation from "@/filiation/composables/useFiliation";
import { Modal } from "bootstrap";
import {
  DxDataGrid,
  DxFilterRow,
  DxHeaderFilter,
  DxPager,
  DxPaging,
  DxGroupPanel,
  DxGrouping,
  DxExport,
  DxSelection,
  DxColumn,
  DxSearchPanel,
  DxSummary,
  DxGroupItem,
  DxSortByGroupSummaryInfo,
  DxTotalItem,
} from "devextreme-vue/data-grid";
import "devextreme/dist/css/dx.light.css";
import Datepicker from "vue3-date-time-picker";
export default defineComponent({
  name: "transferOrderList",
  components: {
    DxDataGrid,
    DxFilterRow,
    DxHeaderFilter,
    DxPager,
    DxPaging,
    DxGroupPanel,
    DxGrouping,
    DxExport,
    DxSelection,
    DxColumn,
    DxSearchPanel,
    DxSummary,
    DxGroupItem,
    DxSortByGroupSummaryInfo,
    DxTotalItem,
    Datepicker,
  },
  setup() {
    const modalRef = ref(null);
    const { passData } = filiation();
    const tipo_ = [
      { id: "salidas", name: "salidas_revisadas" },
      { id: "salidas", name: "salidas_pendientes" },
      { id: "traslados", name: "traslado_llegadas" },
      { id: "traslados", name: "traslado_salidas" },
      { id: "detencion_domiciliaria", name: "detencion_domiciliaria_activas" },
      // eslint-disable-next-line prettier/prettier
      { id: "detencion_domiciliaria", name: "detencion_domiciliaria_revocadas"},
      { id: "extramuro", name: "extramuro_activas" },
      { id: "extramuro", name: "extramuro_revocadas" },
      { id: "libertad_condicional", name: "libertad_condicional_activas" },
      { id: "libertad_condicional", name: "libertad_condicional_revocadas" },
      { id: "libertad_provisional", name: "libertad_provisional_activas" },
      { id: "libertad_provisional", name: "libertad_provisional_revocadas" },
      // eslint-disable-next-line prettier/prettier
      { id: "suspension_condicional_pena", name: "suspension_condicional_pena_activas" },
      // eslint-disable-next-line prettier/prettier
      { id: "suspension_condicional_pena", name: "suspension_condicional_pena_revocadas" },
      // eslint-disable-next-line prettier/prettier
      { id: "suspension_condicional_proceso", name: "suspension_condicional_proceso_activas" },
      // eslint-disable-next-line prettier/prettier
      { id: "suspension_condicional_proceso", name: "suspension_condicional_proceso_revocadas" },
      { id: "perdon_judicial", name: "perdon_judicial_activas" },
      { id: "fallecimiento", name: "fallecimiento" },
      { id: "evasion", name: "evasion_activas" },
      { id: "evasion", name: "evasion_recapturas" },
    ];
    date.locale(es);
    loadMessages(esMessages);
    locale(navigator.language);
    let dataGridRef = ref();
    const currentDateView = date.format(new Date(), "dddd, DD MMMM YYYY HH:mm:ss");
    const now = new Date();
    const pattern = date.compile("MM DD YYYY");
    const currentDate = date.format(now, pattern);
    const pageSizes = ref([10, 25, 50, 100]);
    const tipo = ref("");
    const tipo_orden_valor = ref("");
    const file = ref(null);
    const route = useRoute();
    const router = useRouter();
    const {
      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
      id_recinto,
    } = useAuth();
    const {
      getList,
      uploadFile,
      uploadFileRevocation,
      resolution,
      resolutionRevocation,
      deleteFile,
      deleteFileRevocation,
      receive_transfer,
      printAddTransferDeparture,
      repeal_order,
      send_recapture,
    } = addTransfersDepartures();
    let dataTable = ref([]);
    let types = ref([]);
    const find_type = (value) => {
      const found = tipo_.filter((element) => element.id === value);
      types.value = found;
    };
    const list = async (type) => {
      tipo.value = type;
      const { data } = await getList({
        type_list: type,
        id_penitentiary_center: id_recinto,
        departamento_supervisar,
      });
      dataTable.value = data.data;
    };
    const tipo_orden = computed(() => route.params.type_order);
    tipo_orden_valor.value = tipo_orden.value;
    find_type(tipo_orden_valor.value);
    watch(tipo_orden, (value) => {
      let val;
      if (value === "detencion_domiciliaria") {
        val = "Detención Domiciliaria";
      } else if (value === "extramuro") {
        val = "Extramuro";
      } else if (value === "libertad_condicional") {
        val = "Libertad Condicional";
      } else if (value === "libertad_provisional") {
        val = "Libertad Provisional";
      } else if (value === "suspension_condicional_pena") {
        val = "Suspensión Condicional de la Pena";
      } else if (value === "suspension_condicional_proceso") {
        val = "Suspensión Condicional del Proceso";
      } else if (value === "perdon_judicial") {
        val = "Perdón Judicial";
      } else if (value === "fallecimiento") {
        val = "Fallecimientos";
      } else if (value === "evasion") {
        val = "Evasión";
      } else {
        val = value;
      }
      tipo_orden_valor.value = value;
      value !== undefined
        ? setCurrentPageBreadcrumbs(
            `${val[0].toUpperCase() + val.substring(1)}`,
            ["Listas"]
          )
        : "";
      dataTable.value = [];
      tipo.value = "";
      find_type(value);
    });
    const dataGrid = computed(() => {
      return dataGridRef.value.instance;
    });
    const DateFormat = (date) => {
      const formattedDate = formatDate(date);
      return formattedDate;
    };
    const formatDateAndHours = (date) => {
      const formattedDate = formatDateWithHours(date);
      return formattedDate;
    };
    const onExporting = (e) => {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("tableData");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "SirepReport.xlsx"
          );
        });
      });
      e.cancel = true;
    };
    const uploadResolution = (e) => {
      document.getElementById(e).click();
    };
    const handleFileUpload = async (event, id, tipo) => {
      file.value = event.target.files[0];
      const { data } = await uploadFile([file.value, id.id_traslado_salida]);
      if (data.ok) {
        Swal.fire({
          title: "Archivo cargado correctamente",
          text: "El archivo pdf fue cargado exitosamente.",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
        tipo === "traslados"
          ? await list("traslado_salidas")
          : tipo === "salidas"
          ? await list("salidas_pendientes")
          : tipo === "detencion_domiciliaria"
          ? await list("detencion_domiciliaria_activas")
          : tipo === "extramuro"
          ? await list("extramuro_activas")
          : tipo === "libertad_condicional"
          ? await list("libertad_condicional_activas")
          : tipo === "libertad_provisional"
          ? await list("libertad_provisional_activas")
          : tipo === "suspension_condicional_pena"
          ? await list("suspension_condicional_pena_activas")
          : tipo === "suspension_condicional_proceso"
          ? await list("suspension_condicional_proceso_activas")
          : tipo === "perdon_judicial"
          ? await list("perdon_judicial_activas")
          : tipo === "fallecimiento"
          ? await list("fallecimiento")
          : tipo === "evasion"
          ? await list("evasion_activas")
          : "";
      } else {
        Swal.fire({
          title: "Error",
          text: "El archivo no pudo ser cargado.",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
      }
    };
    const handleFileUploadRevocation = async (event, id, tipo) => {
      file.value = event.target.files[0];
      const { data } = await uploadFileRevocation([
        file.value,
        id.id_traslado_salida,
      ]);
      if (data.ok == true) {
        Swal.fire({
          title: "Archivo cargado correctamente",
          text: "El archivo pdf fue cargado exitosamente.",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
        //await list("detencion_domiciliaria_revocadas");
        tipo === "detencion_domiciliaria"
          ? await list("detencion_domiciliaria_revocadas")
          : tipo === "extramuro"
          ? await list("extramuro_revocadas")
          : tipo === "libertad_condicional"
          ? await list("libertad_condicional_revocadas")
          : tipo === "libertad_provisional"
          ? await list("libertad_provisional_revocadas")
          : tipo === "suspension_condicional_pena"
          ? await list("suspension_condicional_pena_revocadas")
          : tipo === "suspension_condicional_proceso"
          ? await list("suspension_condicional_proceso_revocadas")
          : tipo === "evasion"
          ? await list("evasion_recapturas")
          : "";
      } else {
        Swal.fire({
          title: "Error",
          text: "El archivo no pudo ser cargado.",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
      }
    };
    const printKardex = async (id, tipo) => {
      if (
        tipo === "detencion_domiciliaria" ||
        tipo === "extramuro" ||
        tipo === "libertad_condicional" ||
        tipo === "libertad_provisional" ||
        tipo === "suspension_condicional_pena" ||
        tipo === "suspension_condicional_proceso" ||
        tipo === "perdon_judicial"
      ) {
        await printAddTransferDeparture({ id: id, tipo: "salidas" });
      } else {
        await printAddTransferDeparture({ id: id, tipo: tipo });
      }
    };
    const viewResolution = async (id) => {
      await resolution(id);
    };
    const viewResolutionRevocation = async (id) => {
      await resolutionRevocation(id);
    };
    const swalWithBootstrapButtons = Swal.mixin({
      confirmButtonText: "Continuar",
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    const deleteResolution = async (dato, tipo) => {
      Swal.fire({
        title: `¿Está seguro de eliminar el archivo PDF?`,
        text: "No podrá revertir esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, eliminar",
        cancelButtonText: `Cancelar`,
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await deleteFile(dato.id_traslado_salida);
          if (data.ok === true) {
            swalWithBootstrapButtons.fire(
              "¡Eliminado!",
              "El archivo fue eliminado satisfactoriamente.",
              "success"
            );
            tipo === "traslados"
              ? await list("traslado_salidas")
              : tipo === "salidas"
              ? await list("salidas_pendientes")
              : tipo === "detencion_domiciliaria"
              ? await list("detencion_domiciliaria_activas")
              : tipo === "extramuro"
              ? await list("extramuro_activas")
              : tipo === "libertad_condicional"
              ? await list("libertad_condicional_activas")
              : tipo === "libertad_provisional"
              ? await list("libertad_provisional_activas")
              : tipo === "suspension_condicional_pena"
              ? await list("suspension_condicional_pena_activas")
              : tipo === "suspension_condicional_proceso"
              ? await list("suspension_condicional_proceso_activas")
              : tipo === "perdon_judicial"
              ? await list("perdon_judicial_activas")
              : tipo === "fallecimiento"
              ? await list("fallecimiento")
              : tipo === "evasion"
              ? await list("evasion_activas")
              : "";
          } else {
            Swal.fire({
              title: "Error",
              text: "El archivo no pudo ser eliminado.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            });
          }
        }
      });
    };
    const deleteResolutionRevocation = async (dato, tipo) => {
      Swal.fire({
        title: `¿Está seguro de eliminar el archivo PDF?`,
        text: "No podrá revertir esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, eliminar",
        cancelButtonText: `Cancelar`,
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await deleteFileRevocation(dato.id_traslado_salida);
          if (data.ok === true) {
            swalWithBootstrapButtons.fire(
              "¡Eliminado!",
              "El archivo fue eliminado satisfactoriamente.",
              "success"
            );
            tipo === "detencion_domiciliaria"
              ? await list("detencion_domiciliaria_revocadas")
              : tipo === "extramuro"
              ? await list("extramuro_revocadas")
              : tipo === "libertad_condicional"
              ? await list("libertad_condicional_revocadas")
              : tipo === "libertad_provisional"
              ? await list("libertad_provisional_revocadas")
              : tipo === "suspension_condicional_pena"
              ? await list("suspension_condicional_pena_revocadas")
              : tipo === "suspension_condicional_proceso"
              ? await list("suspension_condicional_proceso_revocadas")
              : tipo === "evasion"
              ? await list("evasion_recapturas")
              : "";
          } else {
            Swal.fire({
              title: "Error",
              text: "El archivo no pudo ser eliminado.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            });
          }
        }
      });
    };
    const confirmReception = async (info) => {
      const { value: codigo_file } = Swal.fire({
        title: `¿Está seguro de realizar la recepción de la persona privada de libertad ${info.persona_ppl} remitida 
                  del Centro Penitenciario ${info.anterior}?`,
        text: "Registre el nuevo código file del ppl.",
        icon: "question",
        input: "text",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Recepcionar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        inputValidator: (value) => {
          if (!value) {
            return "Debe registrar el nuevo Código file del privado de libertad";
          }
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await receive_transfer({
            id_transfer: info.id_traslado_salida,
            id_order: info.cod_ordenes_judiciales_ppl,
            new_cod: result.value,
          });
          if (data.ok) {
            Swal.fire(
              "¡Recepcionado!",
              `${data.message} en el Centro Penitenciario ${info.nuevo}. con el Código File ${codigo_file}`,
              "success"
            );
            list("traslado_llegadas");
          } else {
            Swal.fire(
              "¡Atención!",
              `No se pudo realizar la recepción, por favor contáctese con el administrador.`,
              "error"
            );
          }
        }
      });
    };
    const approveLiberty = async (info) => {
      localStorage.setItem("paraAprobar", JSON.stringify(info));
      router.push({
        name: "resume_orders",
        params: {
          tipo: "verificar",
        },
      });
    };
    const deny_details = async (id_salida) => {
      const dato = dataTable.value.filter(
        (value) => value.id_traslado_salida === id_salida
      );
      Swal.fire(
        "Detalles negación salida por libertad definitiva ",
        `${dato[0].observacion_rechazo_salida_libertad}`,
        "info"
      );
    };
    const repealOrder = async (info, tipo) => {
      await Swal.fire({
        title: `¿Está seguro de revocar la  orden de ${info.descripcion_tipo_mandamiento} de la persona privada de libertad ${info.persona_ppl}?`,
        text: "No podrá revertir esta acción.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, continuar",
        cancelButtonText: "Volver",
        reverseButtons: true,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await repeal_order(info.id_traslado_salida);
          if (data.ok) {
            Swal.fire("¡Cancelado!", `${data.message}.`, "success");
            tipo === "detencion_domiciliaria"
              ? await list("detencion_domiciliaria_revocadas")
              : tipo === "extramuro"
              ? await list("extramuro_revocadas")
              : tipo === "libertad_condicional"
              ? await list("libertad_condicional_revocadas")
              : tipo === "libertad_provisional"
              ? await list("libertad_provisional_revocadas")
              : tipo === "suspension_condicional_pena"
              ? await list("suspension_condicional_pena_revocadas")
              : tipo === "suspension_condicional_proceso"
              ? await list("suspension_condicional_proceso_revocadas")
              : tipo === "evasion"
              ? await list("evasion_recapturas")
              : "";
          } else {
            Swal.fire(
              "¡Atención!",
              `No se pudo realizar la revocación de la detención domiciliaria, por favor contáctese con el administrador.`,
              "error"
            );
          }
        }
      });
    };
    const sinFechaRecaptura = ref(false);
    const recapturePpl = async (info, tipo) => {
      if (state.formData.fecha_recaptura == "") {
        document.getElementById("fecha_recaptura").style.border =
          "2px solid red";
        sinFechaRecaptura.value = true;
        return false;
      } else {
        sinFechaRecaptura.value = false;
        document.getElementById("fecha_recaptura").style.border =
          "0px solid grey";
        const { data } = await send_recapture({
          id: info.id_traslado_salida,
          id_persona: info.id_persona,
          fecha_recaptura: state.formData.fecha_recaptura,
        });
        if (data.ok) {
          Swal.fire("¡Registrado!", `${data.message}`, "success");
          await printAddTransferDeparture({
            id: info.id_traslado_salida,
            tipo: tipo,
          });
          Modal.getInstance(modalRef.value).hide();
          clearInput();
          await list("evasion_recapturas");
        }
        return true;
      }
    };
    const clearInput = () => {
      document.getElementById("fecha_recaptura").style.border =
        "0px solid grey";
      sinFechaRecaptura.value = false;
      state.formData.fecha_recaptura = "";
    };
    const save_and_register_new_order = async (data) => {
      const { info, tipo, id_persona, id_orden, add } = data;
      let d = await recapturePpl(info, tipo);
      if (d) {
        await passData({
          id_persona,
          id_orden_judicial: id_orden,
          tipo: "nuevo",
        });
        router.push({
          name: "addOrTransferOrDeparture",
          params: {
            id_persona,
            id_orden_judicial: id_orden,
            tipo: "nuevo",
            add,
          },
        });
      }
      //Modal.getInstance(modalRef.value).hide();
    };
    const state = reactive({
      formData: {
        fecha_recaptura: "",
      },
    });
    const deleteValidation = (e) => {
      if (e) {
        document.getElementById("fecha_recaptura").style.border =
          "0px solid grey";
        sinFechaRecaptura.value = false;
      }
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("Listas", ["Listas"]);
    });
    return {
      state,
      date,
      tipo,
      currentDateView,
      currentDate,
      pageSizes,
      dataTable,
      dataGridRef,
      dataGrid,
      tipo_orden_valor,
      types,
      onExporting,
      list,
      setCurrentPageBreadcrumbs,
      DateFormat,
      formatDateAndHours,
      uploadResolution,
      handleFileUpload,
      handleFileUploadRevocation,
      viewResolution,
      viewResolutionRevocation,
      deleteResolution,
      deleteResolutionRevocation,
      confirmReception,
      approveLiberty,
      deny_details,
      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
      printKardex,
      repealOrder,
      recapturePpl,
      sinFechaRecaptura,
      clearInput,
      save_and_register_new_order,
      modalRef,
      deleteValidation,
    };
  },
});
</script>
